import { useEffect, useState } from 'react';
/*
  * This hook allows you to use local or session storage as a state.
  * It also allows you to remove the value from the storage.
 */
const useBrowserStorage = (storage, key, initialValue) => {
    const computedValue = storage.getItem(key);
    const [storedValue, setStoredValueInteral] = useState(computedValue !== null ? JSON.parse(computedValue) : initialValue);
    const setStorageValue = (value) => {
        if (value === initialValue)
            storage.removeItem(key);
        else
            storage.setItem(key, JSON.stringify(value));
    };
    const setStoredValue = (value) => {
        setStorageValue(value);
        setStoredValueInteral(value);
    };
    const removeStoredValue = () => setStoredValue(initialValue);
    // Technically this is also done by the setter method. Initially we had its contents here, but in practice 
    // we found that the clear/set was lagging behind due to the internal react loop. It needed to be faster.
    useEffect(() => setStorageValue(storedValue), [storedValue]);
    return [storedValue, setStoredValue, removeStoredValue];
};
export const useLocalStorage = (key, initialValue) => useBrowserStorage(localStorage, key, initialValue);
export const useSessionStorage = (key, initialValue) => useBrowserStorage(sessionStorage, key, initialValue);
